import axios from '../../../../utills/axiosConfig';

export const fetchFGPurities = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/fg-purities', { params });
  return res.data;
};

export const addFGPurity = async (fgPurity) => {
  try {
    const res = await axios.post('/fg-purities', fgPurity);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateFGPurity = async (id, fgPurity) => {
  console.log('API call - Updating FG Purity:', id, fgPurity);
  const res = await axios.put(`/fg-purities/${id}`, fgPurity);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteFGPurity = async (id) => {
  const res = await axios.delete(`/fg-purities/${id}`);
  return res.data;
};

export const importFGPurityCSV = async (formData) => {
  const { data } = await axios.post('/fg-purities/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 